(() => {
  if (window.clashNativeLocalizationLoaded) return;
  window.clashNativeLocalizationLoaded = true;
  const picker = document.querySelector('[data-clash-country]');
  const form = picker?.querySelector('form');
  const select = form?.querySelector('[name="country_code"]');
  const choiceKey = 'clash-native-country-choice';
  const attemptKey = 'clash-native-country-detected';
  let manualSelectionStarted = false;
  const read = (getStorage, key) => { try { return getStorage().getItem(key); } catch { return null; } };
  const write = (getStorage, key, value) => { try { getStorage().setItem(key, value); } catch {} };
  form?.addEventListener('submit', () => {
    write(() => localStorage, choiceKey, select.value);
  });
  select?.addEventListener('change', () => { manualSelectionStarted = true; });

  const browser = picker?.querySelector('[data-country-browser]');
  if (browser && select) {
    const search = browser.querySelector('input');
    const list = browser.querySelector('ul');
    const results = browser.querySelector('[data-country-results]');
    const trigger = picker.querySelector('summary');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const entries = Array.from(select.options).map(option => {
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'clash-country__option';
      button.dataset.country = option.value;
      const code = document.createElement('span');
      code.className = 'clash-country__code';
      code.textContent = option.value;
      const name = document.createElement('span');
      name.className = 'clash-country__name';
      name.textContent = option.textContent.trim().replace(/\s+—\s+[A-Z]{3}$/, '');
      const currency = document.createElement('span');
      currency.className = 'clash-country__currency';
      currency.textContent = option.dataset.currency;
      const check = document.createElement('span');
      check.className = 'clash-country__check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';
      button.append(code, name, currency, check);
      button.setAttribute('aria-pressed', String(option.selected));
      button.addEventListener('click', () => {
        if (select.value === option.value) {
          picker.open = false;
          trigger.focus({preventScroll: true});
          return;
        }
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
        entries.forEach(entry => entry.button.setAttribute('aria-pressed', String(entry.button === button)));
        form.requestSubmit();
      });
      item.append(button);
      list.append(item);
      return {item, button, text: normalize(option.textContent + ' ' + option.value)};
    });
    const filter = () => {
      const terms = normalize(search.value.trim()).split(/\s+/);
      let count = 0;
      entries.forEach(entry => {
        entry.item.hidden = !terms.every(term => entry.text.includes(term));
        if (!entry.item.hidden) count++;
      });
      results.textContent = results.dataset.template.replace('[count]', count);
      list.scrollTop = 0;
    };
    search.addEventListener('input', filter);
    browser.addEventListener('keydown', event => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const visible = entries.filter(entry => !entry.item.hidden).map(entry => entry.button);
      if (!visible.length) return;
      event.preventDefault();
      const index = visible.indexOf(document.activeElement);
      const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : visible.length - 1) :
        (index + (event.key === 'ArrowDown' ? 1 : -1) + visible.length) % visible.length;
      visible[next].focus();
    });
    picker.addEventListener('toggle', () => {
      if (picker.open) {
        search.value = '';
        filter();
        search.focus({preventScroll: true});
        entries.find(entry => entry.button.dataset.country === select.value)?.button.scrollIntoView({block: 'nearest'});
      }
    });
    picker.addEventListener('keydown', event => {
      if (event.key === 'Escape') { picker.open = false; trigger.focus(); }
    });
    document.addEventListener('click', event => {
      if (picker.open && !picker.contains(event.target)) picker.open = false;
    });
    picker.querySelector('label').htmlFor = search.id;
    select.hidden = true;
    browser.hidden = false;
    form.classList.add('clash-country__form--auto-submit');
    filter();
  }

  // Ask Shopify for the visitor's country, then change the actual market.
  // Respect explicit country URLs and the customer's own country selection.
  if (form && !window.Shopify?.designMode &&
      !new URL(location.href).searchParams.has('country') &&
      !read(() => localStorage, choiceKey) && !read(() => sessionStorage, attemptKey)) {
    write(() => sessionStorage, attemptKey, 'pending');
    const root = window.Shopify?.routes?.root || '/';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials: 'same-origin',
      signal: controller.signal
    })
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(data => {
        if (manualSelectionStarted || read(() => localStorage, choiceKey)) return;
        const country = data.detected_values?.country?.handle;
        if (!country || country === picker.dataset.currentCountry) return;
        if (!Array.from(select.options).some(option => option.value === country)) return;
        select.value = country;
        // Auto-detection is not a manual preference.
        HTMLFormElement.prototype.submit.call(form);
      })
      .catch(() => { /* The native selector stays available if detection fails. */ })
      .finally(() => clearTimeout(timeout));
  }

  // Fit the actual formatted price without changing its value or currency.
  const selector = '.pl-price__amount, .pl-price__compare, .product__info-container .price-item, ' +
    '.vfx-ultimate-bundle__current, .vfx-ultimate-bundle__compare, .dk-buy__now, .dk-buy__was, ' +
    '.cart-item__final-price, .cart-item__old-price, .cart-upsell__price strong, .cart-upsell__price s, ' +
    '.atcu__price b, .atcu__price s, .cart-item__totals .price, ' +
    '.totals__total-value, .cart-savings-total__amount';
  const originals = new WeakMap();
  const observed = new WeakSet();
  const fit = element => {
    if (!element.isConnected || !element.getClientRects().length) return;
    if (!originals.has(element)) originals.set(element, element.style.fontSize);
    element.style.fontSize = originals.get(element);
    const parent = element.parentElement;
    const style = getComputedStyle(parent);
    const available = parent.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    const range = document.createRange();
    range.selectNodeContents(element);
    const width = range.getBoundingClientRect().width;
    if (available > 0 && width > available) {
      element.style.fontSize = (parseFloat(getComputedStyle(element).fontSize) * available / width * 0.98) + 'px';
    }
  };
  let pending = false;
  const refresh = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll(selector).forEach(element => {
        if (!observed.has(element.parentElement)) {
          observed.add(element.parentElement);
          resizeObserver.observe(element.parentElement);
        }
        fit(element);
      });
    });
  };
  const resizeObserver = new ResizeObserver(refresh);
  new MutationObserver(refresh).observe(document.body, {childList: true, subtree: true, characterData: true});
  window.addEventListener('resize', refresh, {passive: true});
  document.fonts?.ready.then(refresh);
  refresh();
})();
